// export default ['ru', 'en', 'de', 'tr'];
export default ['de', 'en'];
